import { Injectable } from '@angular/core';


export let REQUESTXML = {
   RUNREPORTRQUEST: `
   <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
      <soapenv:Header/>
      <soapenv:Body>
         <v2:runReport>
            <v2:reportRequest>
               <v2:attributeLocale>en-US</v2:attributeLocale>
               <v2:attributeTemplate>GSG AP Documento Equivalente_T</v2:attributeTemplate>
               <v2:parameterNameValues>
                  <v2:listOfParamNameValues>
                     <v2:item>
                        <v2:name>p_lov_name</v2:name>
                        <v2:values>
                           <v2:item>{item:U}</v2:item>
                        </v2:values>
                     </v2:item>
                  </v2:listOfParamNameValues>
               </v2:parameterNameValues>
               <v2:reportAbsolutePath>/Custom/Prueba_WS/Documento Equivalente Proveedores RS_WS/GSG_CO_Doc_Equivalente_LOV.xdo</v2:reportAbsolutePath>
            </v2:reportRequest>
            <v2:userID>pablo.esquivel</v2:userID>
            <v2:password>Iteria123</v2:password>
         </v2:runReport>
      </soapenv:Body>
   </soapenv:Envelope>`,

  JOURNAL_AP: `
   <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
   <soapenv:Header/>
      <soapenv:Body>
         <v2:runReport>
            <v2:reportRequest>
               <v2:attributeLocale>en-US</v2:attributeLocale>
               <v2:attributeTemplate>Journals_OTR</v2:attributeTemplate>
               <v2:parameterNameValues>
                  <v2:listOfParamNameValues>
                     <v2:item>
                        <v2:name>P_LEDGER</v2:name>
                        <v2:values>
                           <v2:item>{book}</v2:item>
                        </v2:values>
                     </v2:item>
                     <v2:item>
                        <v2:name>P_LEGAL_ENTITY_ID</v2:name>
                        <v2:values>
                           <v2:item>{legalEntity}</v2:item>
                        </v2:values>
                     </v2:item> 
                     <v2:item>
                        <v2:name>P_FIRST_PERIOD</v2:name>
                        <v2:values>
                           <v2:item>{initialPeriod}</v2:item>
                        </v2:values>
                     </v2:item> 
                     <v2:item>
                        <v2:name>P_LAST_PERIOD</v2:name>
                        <v2:values>
                           <v2:item>{finalPeriod}</v2:item>
                        </v2:values>
                     </v2:item> 
                  </v2:listOfParamNameValues>
               </v2:parameterNameValues>
               <v2:reportAbsolutePath>/Custom/ERP-Iteria/COLOKIAL/TERCEROS/Informe_AP.xdo</v2:reportAbsolutePath>
            </v2:reportRequest>
            <v2:userID>pablo.esquivel</v2:userID>
            <v2:password>Iteria123</v2:password>
         </v2:runReport>
      </soapenv:Body>
   </soapenv:Envelope>`,

   JOURNAL_OTR: `
   <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
   <soapenv:Header/>
   <soapenv:Body>
      <v2:runReport>
         <v2:reportRequest>
            <v2:attributeLocale>en-US</v2:attributeLocale>
            <v2:attributeTemplate>Journals_OTR</v2:attributeTemplate>
            <v2:parameterNameValues>
               <v2:listOfParamNameValues>
                  <v2:item>
                     <v2:name>P_LEDGER</v2:name>
                     <v2:values>
                        <v2:item>{book}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_LEGAL_ENTITY_ID</v2:name>
                     <v2:values>
                        <v2:item>{legalEntity}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_FIRST_PERIOD</v2:name>
                     <v2:values>
                        <v2:item>{initialPeriod}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_LAST_PERIOD</v2:name>
                     <v2:values>
                        <v2:item>{finalPeriod}</v2:item>
                     </v2:values>
                  </v2:item>
               </v2:listOfParamNameValues>
            </v2:parameterNameValues>
            <v2:reportAbsolutePath>/Custom/ERP-Iteria/COLOKIAL/TERCEROS/Informe_OTR.xdo</v2:reportAbsolutePath>
         </v2:reportRequest>
         <v2:userID>pablo.esquivel</v2:userID>
         <v2:password>Iteria123</v2:password>
      </v2:runReport>
   </soapenv:Body>
   </soapenv:Envelope>
   `,

   JOURNAL_GL: `
   <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
   <soapenv:Header/>
   <soapenv:Body>
      <v2:runReport>
         <v2:reportRequest>
            <v2:attributeLocale>en-US</v2:attributeLocale>
            <v2:attributeTemplate>Journals_GL</v2:attributeTemplate>
            <v2:parameterNameValues>
               <v2:listOfParamNameValues>
                  <v2:item>
                     <v2:name>P_LEDGER</v2:name>
                     <v2:values>
                        <v2:item>{book}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_LEGAL_ENTITY_ID</v2:name>
                     <v2:values>
                        <v2:item>{legalEntity}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_FIRST_PERIOD</v2:name>
                     <v2:values>
                        <v2:item>{initialPeriod}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_LAST_PERIOD</v2:name>
                     <v2:values>
                        <v2:item>{finalPeriod}</v2:item>
                     </v2:values>
                  </v2:item>
               </v2:listOfParamNameValues>
            </v2:parameterNameValues>
            <v2:reportAbsolutePath>/Custom/ERP-Iteria/COLOKIAL/TERCEROS/Informe_GL.xdo</v2:reportAbsolutePath>
         </v2:reportRequest>
         <v2:userID>pablo.esquivel</v2:userID>
         <v2:password>Iteria123</v2:password>
      </v2:runReport>
   </soapenv:Body>
   </soapenv:Envelope>
   `,
   TERCEROS: `
   <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
   <soapenv:Header/>
   <soapenv:Body>
      <v2:runReport>
         <v2:reportRequest>
            <v2:attributeLocale>en-US</v2:attributeLocale>
            <v2:attributeTemplate>	Extraccion_Terceros</v2:attributeTemplate>
            <v2:parameterNameValues>
               <v2:listOfParamNameValues>
                  <v2:item>
                     <v2:name>P_YEAR</v2:name>
                     <v2:values>
                        <v2:item>{year}</v2:item>
                     </v2:values>
                  </v2:item>
               </v2:listOfParamNameValues>
            </v2:parameterNameValues>
            <v2:reportAbsolutePath>/Custom/ERP-Iteria/COLOKIAL/TERCEROS/Extraccion_Terceros.xdo</v2:reportAbsolutePath>
         </v2:reportRequest>
         <v2:userID>pablo.esquivel</v2:userID>
         <v2:password>Iteria123</v2:password>
      </v2:runReport>
   </soapenv:Body>
   </soapenv:Envelope>
   `,
   BALANCE: `
   <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
   <soapenv:Header/>
   <soapenv:Body>
      <v2:runReport>
         <v2:reportRequest>
            <v2:attributeLocale>en-US</v2:attributeLocale>
            <v2:attributeTemplate>Balance</v2:attributeTemplate>
            <v2:parameterNameValues>
               <v2:listOfParamNameValues>
                  <v2:item>
                     <v2:name>P_LEDGER_ID</v2:name>
                     <v2:values>
                        <v2:item>{book}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_LEGAL_ENTITY_ID</v2:name>
                     <v2:values>
                        <v2:item>{legalEntity}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_FIRST_PERIOD</v2:name>
                     <v2:values>
                        <v2:item>{initialPeriod}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_LAST_PERIOD</v2:name>
                     <v2:values>
                        <v2:item>{finalPeriod}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_CURRENCY</v2:name>
                     <v2:values>
                        <v2:item>{currency}</v2:item>
                     </v2:values>
                  </v2:item>
               </v2:listOfParamNameValues>
            </v2:parameterNameValues>
            <v2:reportAbsolutePath>/Custom/ERP-Iteria/COLOKIAL/TERCEROS/Balance.xdo</v2:reportAbsolutePath>
         </v2:reportRequest>
         <v2:userID>pablo.esquivel</v2:userID>
         <v2:password>Iteria123</v2:password>
      </v2:runReport>
   </soapenv:Body>
   </soapenv:Envelope>
   `,
   PERIODOS_CONTABLES: `
   <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
   <soapenv:Header/>
   <soapenv:Body>
      <v2:runReport>
         <v2:reportRequest>
            <v2:attributeLocale>en-US</v2:attributeLocale>
            <v2:attributeTemplate>Extraccion_Periodos</v2:attributeTemplate>
            <v2:parameterNameValues>
               <v2:listOfParamNameValues>
                  <v2:item>
                     <v2:name>P_YEAR</v2:name>
                     <v2:values>
                        <v2:item>{year}</v2:item>
                     </v2:values>
                  </v2:item>
                  <v2:item>
                     <v2:name>P_LEDGER</v2:name>
                     <v2:values>
                        <v2:item>{ledger}</v2:item>
                     </v2:values>
                  </v2:item>       
                 </v2:listOfParamNameValues>
            </v2:parameterNameValues>         
            <v2:reportAbsolutePath>/Custom/ERP-Iteria/COLOKIAL/TERCEROS/Extraccion_Periodos.xdo</v2:reportAbsolutePath>
         </v2:reportRequest>
         <v2:userID>pablo.esquivel</v2:userID>
         <v2:password>Iteria123</v2:password>
      </v2:runReport>
   </soapenv:Body>
</soapenv:Envelope>
`,
SUPPLIER_LOV: `
   <soapenv:Envelope
   xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/"
   xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
   <soapenv:Header/>
   <soapenv:Body>
      <v2:runReport>
         <v2:reportRequest>
               <v2:attributeLocale>en-US</v2:attributeLocale>
               <v2:attributeTemplate>{item:U}</v2:attributeTemplate>
               <v2:reportAbsolutePath>/Custom/ERP-Iteria/COLOKIAL/DOEQ/Suppliers_LOV.xdo</v2:reportAbsolutePath>
         </v2:reportRequest>
         <v2:userID>{user}</v2:userID>
         <v2:password>{password}</v2:password>
      </v2:runReport>
   </soapenv:Body>
   </soapenv:Envelope>`,
   DOC_SOPORTE: `
   <soapenv:Envelope
   xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/"
   xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
   <soapenv:Header/>
   <soapenv:Body>
      <v2:runReport>
         <v2:reportRequest>
               <v2:attributeLocale>en-US</v2:attributeLocale>
               <v2:attributeTemplate>DOC_SOPORTE</v2:attributeTemplate>
               <v2:parameterNameValues>
                  <v2:listOfParamNameValues>
                     <v2:item>
                        <v2:name>P_LEDGER_ID</v2:name>
                        <v2:values>
                           <v2:item>{ledger}</v2:item>
                        </v2:values>
                     </v2:item>
                     <v2:item>
                        <v2:name>P_LEGAL_ENTITY_ID</v2:name>
                        <v2:values>
                           <v2:item>{entity}</v2:item>
                        </v2:values>
                     </v2:item>
                     <v2:item>
                        <v2:name>P_VENDOR_ID</v2:name>
                        <v2:values>
                           <v2:item>{provider}</v2:item>
                        </v2:values>
                     </v2:item>
                     <v2:item>
                        <v2:name>P_DATE_FROM</v2:name>
                        <v2:values>
                           <v2:item>{startDate}</v2:item>
                        </v2:values>
                     </v2:item>
                     <v2:item>
                        <v2:name>P_DATE_TO</v2:name>
                        <v2:values>
                           <v2:item>{endDate}</v2:item>
                        </v2:values>
                     </v2:item>
                  </v2:listOfParamNameValues>
               </v2:parameterNameValues>
               <v2:reportAbsolutePath>/Custom/ERP-Iteria/COLOKIAL/DOEQ/Documento_Soporte.xdo</v2:reportAbsolutePath>
         </v2:reportRequest>
         <v2:userID>{user}</v2:userID>
         <v2:password>{password}</v2:password>
      </v2:runReport>
   </soapenv:Body>
   </soapenv:Envelope>
   `,
   DOC_SOPORTE_NOT_PROVIDER: `
   <soapenv:Envelope
   xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/"
   xmlns:v2="http://xmlns.oracle.com/oxp/service/v2">
   <soapenv:Header/>
   <soapenv:Body>
      <v2:runReport>
         <v2:reportRequest>
               <v2:attributeLocale>en-US</v2:attributeLocale>
               <v2:attributeTemplate>DOC_SOPORTE</v2:attributeTemplate>
               <v2:parameterNameValues>
                  <v2:listOfParamNameValues>
                     <v2:item>
                        <v2:name>P_LEDGER_ID</v2:name>
                        <v2:values>
                           <v2:item>{ledger}</v2:item>
                        </v2:values>
                     </v2:item>
                     <v2:item>
                        <v2:name>P_LEGAL_ENTITY_ID</v2:name>
                        <v2:values>
                           <v2:item>{entity}</v2:item>
                        </v2:values>
                     </v2:item>
                     <v2:item>
                        <v2:name>P_DATE_FROM</v2:name>
                        <v2:values>
                           <v2:item>{startDate}</v2:item>
                        </v2:values>
                     </v2:item>
                     <v2:item>
                        <v2:name>P_DATE_TO</v2:name>
                        <v2:values>
                           <v2:item>{endDate}</v2:item>
                        </v2:values>
                     </v2:item>
                  </v2:listOfParamNameValues>
               </v2:parameterNameValues>
               <v2:reportAbsolutePath>/Custom/ERP-Iteria/COLOKIAL/DOEQ/Documento_Soporte.xdo</v2:reportAbsolutePath>
         </v2:reportRequest>
         <v2:userID>{user}</v2:userID>
         <v2:password>{password}</v2:password>
      </v2:runReport>
   </soapenv:Body>
   </soapenv:Envelope>
   `
};
@Injectable()
export class SoapRequestService {

  constructor() { }

  findByName(key: string): string {
    if (!key) { return null; }
    return REQUESTXML[key];
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/soap/soap-request.service.ts